// extracted by mini-css-extract-plugin
module.exports = {"block":"rating_block__2EgXK","value":"rating_value__2CMCV","scale":"rating_scale__2XSJb"};